import { render, staticRenderFns } from "./TableDecimal.vue?vue&type=template&id=471fc5e6"
import script from "./TableDecimal.vue?vue&type=script&lang=ts"
export * from "./TableDecimal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports